var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorRightFaransavi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,25.9H14.2V5.2h11.1V25.9z M15.1,24.9h9.2V6.1h-9.2V24.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 15.1,
    rx: 2.2,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.8c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7L28.8,0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 L12.3,15.7C12.2,15.8,12.1,15.8,12,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,29.3c-0.1,0-0.2,0-0.3-0.1L11.7,15.7c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l17.1,13.5 c0.2,0.2,0.2,0.5,0.1,0.7C29.4,29.2,29.2,29.3,29.1,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,25.7H3.5V4.9h3.6V25.7z M4.5,24.7h1.7V5.9H4.5V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,29.7c-0.3,0-0.5-0.2-0.5-0.5V0.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.3C10.5,29.5,10.3,29.7,10.1,29.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorRightFaransavi);
export default __webpack_public_path__ + "static/media/door_right_faransavi.47d66cfaee05eb7d2133bdf4698f3969.svg";
export { ForwardRef as ReactComponent };